var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 450,
    viewBox: "0 0 550 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1441",
    "data-name": "Rectangle 1441",
    width: 550,
    height: 450,
    transform: "translate(347 3577)",
    fill: "#ffe2e2",
    opacity: 0.74
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Services_img_3",
    transform: "translate(-347 -3577)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1188",
    "data-name": "Rectangle 1188",
    width: 586,
    height: 682,
    transform: "translate(329 3461)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1404",
    "data-name": "Group 1404",
    transform: "translate(344.282 3546.064)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_211",
    "data-name": "Line 211",
    x1: 14.522,
    y2: 13.282,
    transform: "translate(271.057 167.126)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M341.34,122.6s-37.263,38.359-46.25,35.948c-6.249-1.676-.416-21.753-18.009-4.072-15.609,15.686-80.753,84.3-125.154,115.028",
    transform: "translate(20.868 8.55)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337",
    transform: "translate(223.321 175.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1404",
    "data-name": "Rectangle 1404",
    width: 247.069,
    height: 197.034,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342",
    transform: "translate(345.314 332.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1405",
    "data-name": "Rectangle 1405",
    width: 24.789,
    height: 40.303,
    transform: "translate(0 24.789) rotate(-90)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M299.107,310.251l10.648-9.487,13.072,12.9,9.006-6.908,7.577,5.64v6.121h-40.3Z",
    transform: "translate(-299.107 -293.725)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_212",
    "data-name": "Line 212",
    x1: 6.743,
    y2: 6.167,
    transform: "translate(353.825 147.388)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1362",
    "data-name": "Group 1362",
    transform: "translate(238.718 264.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1406",
    "data-name": "Rectangle 1406",
    width: 87.151,
    height: 92.8,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361",
    transform: "translate(11.794 13.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    "data-name": "Group 1360",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1347",
    "data-name": "Group 1347",
    transform: "translate(52.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    "data-name": "Group 1346",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1407",
    "data-name": "Rectangle 1407",
    width: 5.523,
    height: 53.471,
    transform: "translate(5.523 53.471) rotate(-180)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351",
    transform: "translate(36.982 7.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    "data-name": "Group 1350",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1349",
    "data-name": "Group 1349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    "data-name": "Group 1348"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1408",
    "data-name": "Rectangle 1408",
    width: 5.523,
    height: 46.118,
    transform: "translate(5.523 46.118) rotate(-180)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355",
    transform: "translate(21.557 2.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    "data-name": "Group 1354",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1409",
    "data-name": "Rectangle 1409",
    width: 5.523,
    height: 51.089,
    transform: "translate(5.523 51.089) rotate(-180)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359",
    transform: "translate(6.132 29.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1410",
    "data-name": "Rectangle 1410",
    width: 5.523,
    height: 23.528,
    transform: "translate(5.523 23.528) rotate(-180)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    x1: 5.523,
    transform: "translate(6.132 64.869)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_214",
    "data-name": "Line 214",
    x1: 5.523,
    transform: "translate(21.557 65.183)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    x1: 5.523,
    transform: "translate(36.982 64.869)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_216",
    "data-name": "Line 216",
    x1: 5.523,
    transform: "translate(52.407 64.869)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_217",
    "data-name": "Line 217",
    x2: 63.563,
    transform: "translate(0 58.939)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1364",
    "data-name": "Group 1364",
    transform: "translate(238.718 189.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    "data-name": "Group 1363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M208.168,172.578v62.637H286.65",
    transform: "translate(-208.168 -172.578)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_218",
    "data-name": "Line 218",
    x2: 78.483,
    transform: "translate(1.086 10.836)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_219",
    "data-name": "Line 219",
    x2: 78.483,
    transform: "translate(1.086 24.03)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    x2: 78.483,
    transform: "translate(1.086 37.225)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_221",
    "data-name": "Line 221",
    x2: 78.483,
    transform: "translate(1.086 50.42)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M208.168,228.579l16.63-15.495,4.354,3.532,47-38.722",
    transform: "translate(-208.168 -171.663)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M347.1,202.821A23.994,23.994,0,1,1,323.1,178.827v23.994Z",
    transform: "translate(46.207 18.231)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M346.571,199.821H322.577V175.827a24,24,0,0,1,23.994,23.994Z",
    transform: "translate(50.248 17.714)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1365",
    "data-name": "Group 1365",
    transform: "translate(408.101 212.733)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_222",
    "data-name": "Line 222",
    x1: 43.37,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_223",
    "data-name": "Line 223",
    x2: 43.37,
    transform: "translate(0 16.434)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    transform: "translate(345.314 266.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367",
    transform: "translate(13.503 1.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    "data-name": "Group 1366"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1411",
    "data-name": "Rectangle 1411",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1369",
    "data-name": "Group 1369",
    transform: "translate(0 1.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1412",
    "data-name": "Rectangle 1412",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1371",
    "data-name": "Group 1371",
    transform: "translate(0 19.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1370",
    "data-name": "Group 1370"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1413",
    "data-name": "Rectangle 1413",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    "data-name": "Group 1373",
    transform: "translate(0 38.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1372",
    "data-name": "Group 1372"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1414",
    "data-name": "Rectangle 1414",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375",
    transform: "translate(13.503 19.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    "data-name": "Group 1374"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1415",
    "data-name": "Rectangle 1415",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    "data-name": "Group 1377",
    transform: "translate(13.503 38.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1416",
    "data-name": "Rectangle 1416",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379",
    transform: "translate(27.007 1.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    "data-name": "Group 1378"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1417",
    "data-name": "Rectangle 1417",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381",
    transform: "translate(27.007 19.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    "data-name": "Group 1380"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1418",
    "data-name": "Rectangle 1418",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1419",
    "data-name": "Rectangle 1419",
    width: 6.752,
    height: 6.752,
    transform: "translate(13.503)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383",
    transform: "translate(27.007 38.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    transform: "translate(40.51 1.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387",
    transform: "translate(40.51 38.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1422",
    "data-name": "Rectangle 1422",
    width: 6.752,
    height: 6.752,
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1389",
    "data-name": "Group 1389",
    transform: "translate(39.351 18.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1423",
    "data-name": "Rectangle 1423",
    width: 9.071,
    height: 9.071,
    fill: "#1b1a19"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    "data-name": "Group 1391",
    transform: "translate(12.358 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1390",
    "data-name": "Group 1390"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1424",
    "data-name": "Rectangle 1424",
    width: 9.071,
    height: 9.071,
    fill: "#1b1a19"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M443.375,164.366v40.516H411.018",
    transform: "translate(65.475 15.741)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    "data-name": "Group 1393",
    transform: "translate(493.23 122.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M440.91,115.211v47L425.3,155.141V122.268Z",
    transform: "translate(-425.297 -115.211)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M454.23,122.256v32.885l-15.613,7.068v-47h.012Z",
    transform: "translate(-423.004 -115.211)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M456.534,150.309l-15.613,7.064L425.3,150.309l15.621-7.055Z",
    transform: "translate(-425.297 -110.383)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394",
    transform: "translate(233.173 396.645)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 3.788,
    cy: 3.788,
    r: 3.788,
    transform: "translate(0 0)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 3.788,
    cy: 3.788,
    r: 3.788,
    transform: "translate(17.13 0)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 3.788,
    cy: 3.788,
    r: 3.788,
    transform: "translate(34.26 0)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 3.788,
    cy: 3.788,
    r: 3.788,
    transform: "translate(0 34.26)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 3.788,
    cy: 3.788,
    r: 3.788,
    transform: "translate(0 17.13)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 3.788,
    cy: 3.788,
    r: 3.788,
    transform: "translate(17.13 34.26)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 3.788,
    cy: 3.788,
    r: 3.788,
    transform: "translate(17.13 17.13)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 3.788,
    cy: 3.788,
    r: 3.788,
    transform: "translate(34.26 34.26)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 3.788,
    cy: 3.788,
    r: 3.788,
    transform: "translate(34.26 17.13)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    "data-name": "Group 1401",
    transform: "translate(395.317 233.775)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1425",
    "data-name": "Rectangle 1425",
    width: 59.649,
    height: 17.601,
    transform: "translate(121.213 152.405) rotate(-180)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1396",
    "data-name": "Group 1396",
    transform: "translate(0 94.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M367.132,370.814l-2.709,9.043-7.624-3.266,2.71-8.874Z",
    transform: "translate(-339.177 -277.838)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M368.445,376.945a.791.791,0,0,0-1.094-.651,6.249,6.249,0,0,1-4.636.068c-2.135-.754-2.656-2.09-2.75-2.975a.8.8,0,0,0-.922-.728l-14.814,2.4a3.436,3.436,0,0,0-2.236,1.383h0a1.2,1.2,0,0,0,.7,1.87l23.051,5.347a1.623,1.623,0,0,0,1.967-1.3l.8-4.5a.731.731,0,0,0,.007-.226Z",
    transform: "translate(-341.766 -276.988)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M400.082,369.005l1.28,9.415-8.347.178-1.209-9.262Z",
    transform: "translate(-333.15 -277.616)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M378.658,319.283s4.576,24.944,4.573,25.353l7.238,35.544,6.768.846,6.171-.771-5.1-42.323L395.254,313.8Z",
    transform: "translate(-335.414 -287.12)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M404.2,375.318a.8.8,0,0,0-1.268-.184,6.292,6.292,0,0,1-4.288,1.845c-2.274.118-3.273-.924-3.7-1.711a.811.811,0,0,0-1.138-.322l-12.857,7.927a3.443,3.443,0,0,0-1.548,2.146h0a1.207,1.207,0,0,0,1.371,1.469l23.5-3.887a1.635,1.635,0,0,0,1.332-1.965l-.987-4.494a.8.8,0,0,0-.08-.213Z",
    transform: "translate(-335.292 -276.613)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395",
    transform: "translate(14.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M409.457,291.9l-6.5,17.347s-23.269-8.5-34.114,2.974c-7.143,7.559-15.083,70.365-15.083,70.365l6.257,1.956,8.886.407,11.347-48.9s2.21-6.066,4.013-6.886c3.438-1.562,18.106,1.9,18.106,1.9l15.612.067c20.768-.1,25.668-8.268,25.409-16.608a60.1,60.1,0,0,0-1.785-14.108l-2.252-9.374Z",
    transform: "translate(-353.76 -291.039)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M397.272,329.666l-11.6,26-4.411-22.686-1.475-9.351,6.271-.44,10.693,2.33Z",
    transform: "translate(-335.22 -285.504)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M402.6,303.66l-11.286,4.19,15.2-1.667Z",
    transform: "translate(-333.235 -194.052)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1398",
    "data-name": "Group 1398",
    transform: "translate(35.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M372.368,303.861s23.346-10.022,27.322-11.726c2.5-1.076,3.535-5.373,3.961-8.4.239-.545.478-1.129.726-1.741-.046-3.035-.1-6.681-.165-11.069-.231-15.358,13.034-29.033,13.034-29.033s-13.535,2.294-15.127,8.116c-1.24,4.566-7.242,26.538-9.79,35.872-2.025.934-17.771,8.258-19.58,10.664C370.806,299.108,372.368,303.861,372.368,303.861Z",
    transform: "translate(-371.774 -204.686)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M410.831,249.7c-.049.032,5.5,1.926,9.212.282,3.491-1.543,6.135-7.286,6.084-7.29-1.588-.073-3.331-1.462-4.675-10.572l-.676.243-11.37,4.091s.824,3.649,1.357,7.122C411.211,246.489,411.453,249.283,410.831,249.7Z",
    transform: "translate(-365.295 -206.369)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M409.406,236.415s.824,3.649,1.357,7.122c6.53-1.176,9.094-7.682,10.013-11.213Z",
    transform: "translate(-365.295 -206.334)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M409.135,242.923s15.556-2.089,14.107-11.757-.417-16.448-10.412-15.524-11.365,4.9-11.667,8.247S405.05,243.216,409.135,242.923Z",
    transform: "translate(-366.717 -209.22)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M426.687,240.83c-13.146,7.81-14.208,1.248-14.208,1.248s-13.264,13.676-13.033,29.033c.471,31.493-.334,37.383,3.112,40.372.829.719,3.16,1.144,6.232,1.346,3.542.239,7.873.832,12.223.557,2.987.358,8.431.237,13.99.414.365.012.852-10,1.217-10.049,7.706-.989,15.589-2.755,19.208-5.278,7.093-4.941-5.276-41.993-11.508-50.684-4.432-6.173-17.219-6.965-17.219-6.965Zm11.5,48.535a62.157,62.157,0,0,1,.85-9.276c.036-.217.082-.434.134-.651,2.422,3.834,4.319,6.994,3.924,7.391A19.215,19.215,0,0,1,438.19,289.365Z",
    transform: "translate(-367.011 -204.87)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M407.687,306.245c.356,1.03,26.312,1.237,26.678-.626,1.308-6.659,1.4-18.208,3.258-27.663q.29-1.512.717-3.28c1.546-6.495,3.056-8.7-2.437-19.132-.418-.8-.844-1.585-1.262-2.354-.418,7.816-1.541,43.861-4.956,46.91-4.305,3.841-18.037-1.388-20.13,1.825A11.75,11.75,0,0,0,407.687,306.245Z",
    transform: "translate(-365.591 -202.741)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397",
    transform: "translate(38.101 94.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M406.376,301.379c.631-.62,1.28-1.3,1.781-1.782.162-.157.315-.292.436-.393.737-.613,3.323-.842,4.591-.979,5.353-.549,7.836-2.63,7.836-2.63l-1.083-4.72s-10.841,2.259-12.03,3.847a30.7,30.7,0,0,0-2.7,4.991,9.352,9.352,0,0,0-.925,2.874C404.284,303.339,405.291,302.456,406.376,301.379Z",
    transform: "translate(-404.279 -290.875)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M440.888,247.384c6.307,8.64,18.6,45.745,11.512,50.687-7.981,5.564-35.027,6.719-35.027,6.719s-.944-4.409.369-6.541,21.342-10.84,22.325-11.825-12.3-19.192-12.3-22.145h0c-1.105-14.269,1.415-17.119,3.6-19.736,2.193-2.632,5.291-.681,5.291-.681A14.638,14.638,0,0,1,440.888,247.384Z",
    transform: "translate(-363.98 -204.467)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M422.693,240.821v.007a.025.025,0,0,1,.015-.007Z",
    transform: "translate(-363.008 -204.871)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M397.493,218.423a32.131,32.131,0,0,0,8.134-5.184c3.371-2.918,8.88-2.589,10.742-2.247a2.485,2.485,0,0,0-.69-.84,2.249,2.249,0,0,1,1.205.964c.091.03.136.059.121.076a2.882,2.882,0,0,1,1.363-.332s-.382.062-.44.339a.241.241,0,0,1-.037.083c7.008,1.037,10.58,10.483,9.318,13.322a81.076,81.076,0,0,0-3.182,10.591,11.541,11.541,0,0,1-1.061-3.852c-.309-2.491-2.344-1.854-5.251-2.122s-1.7-3.937-4.522-5.054-10.735,2.534-11.063,1.109C398.716,225.116,397.591,218.736,397.493,218.423Z",
    transform: "translate(-367.346 -210.151)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M429.732,303.942s.764-4.607-4.049-4.876,5.8-1.148,5.8-1.148l-.926,6.024Z",
    transform: "translate(-362.709 -195.041)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400",
    transform: "translate(8.707 77.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M412.877,312.517H363.921L349.194,275.9h48.881Z",
    transform: "translate(-349.194 -275.895)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M361.268,305.921h64.647v2.6H361.842Z",
    transform: "translate(-347.115 -270.726)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M371.6,291.983a2.307,2.307,0,0,1,2.261-3.171,4.544,4.544,0,0,1,4.079,3.171,2.307,2.307,0,0,1-2.261,3.17A4.542,4.542,0,0,1,371.6,291.983Z",
    transform: "translate(-345.358 -273.671)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    "data-name": "Group 1403",
    transform: "translate(30.718 267.669)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 14.705,
    cy: 53.018,
    rx: 14.705,
    ry: 53.018,
    transform: "translate(29.742 39.76)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M144.014,262.915a19.983,19.983,0,0,0,5.081,10.228,36.814,36.814,0,0,1,2.518,2.7,5.6,5.6,0,0,1,1.3,3.377,3.074,3.074,0,0,1-1.9,2.9c-1.641.557-3.618-.68-5.1.213a3.3,3.3,0,0,0-1.15,3.338,18.357,18.357,0,0,1,.545,3.688,4.251,4.251,0,0,1-6.664,3.215c-.742-.509-1.471-1.3-2.356-1.137a2.762,2.762,0,0,0-1.448,1.144,6.54,6.54,0,0,1-3.2,2.236,3.593,3.593,0,0,1-3.635-.96c-.348-.382-.558-.874-.915-1.25a1.278,1.278,0,0,0-1.388-.414,2.7,2.7,0,0,0-.75.748c-1.156,1.307-3.323.945-4.818.039a11.58,11.58,0,0,1-5.174-8.681,18.89,18.89,0,0,1,2.044-10.135,56.582,56.582,0,0,1,5.611-8.821",
    transform: "translate(-16.229 -234.961)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M64.031,289.111a7.244,7.244,0,0,1,2.933-.438,22.556,22.556,0,0,1,16.721,8.556,31.32,31.32,0,0,1,6.531,17.912c.2,3.439-.459,8.923-2.278,11.852-3.344-2.266-6.324-7.49-7.639-11.334s-2.329-7.853-4.73-11.1c-2.784-3.763-7.086-6.031-10.866-8.791a8.822,8.822,0,0,1-2.055-1.922,3.339,3.339,0,0,1-.617-2.667A3.277,3.277,0,0,1,64.031,289.111Z",
    transform: "translate(-25.338 -230.529)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    "data-name": "Group 1402",
    transform: "translate(36 58.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M63.535,289.034a7.411,7.411,0,0,1,3-.448,23.035,23.035,0,0,1,17.075,8.736,31.99,31.99,0,0,1,6.67,18.292c.2,3.512-.47,9.111-2.326,12.1-3.416-2.314-6.457-7.648-7.8-11.574s-2.377-8.02-4.828-11.334c-2.844-3.842-7.237-6.159-11.1-8.976a9.076,9.076,0,0,1-2.1-1.963,3.411,3.411,0,0,1-.629-2.724A3.345,3.345,0,0,1,63.535,289.034Z",
    transform: "translate(-61.431 -288.574)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M88.514,319.061l-4.935,4.267s-.774,2.579-2,3.282-5.31,4.888-5.31,4.888,1.512,1.887-1.348,4.911c0,0,1.242,3.411.41,6.154-.586,1.981-6.107,18.016-10.151,28.167-2.215-3.352-4.149-8.651-5.626-15.3-.246-1.055-.469-2.145-.68-3.27a159.919,159.919,0,0,1-2.508-29.246,163.185,163.185,0,0,1,2.145-27.206,119.843,119.843,0,0,1,16.117-4.782c.3.34,10.714,11.265,12.214,20.9Z",
    transform: "translate(-26.303 -230.138)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M67.431,292.029l.241.265.689.756,2.534,2.782a52.412,52.412,0,0,1,3.525,4.314,30.724,30.724,0,0,1,3.45,5.846,45.932,45.932,0,0,1,3.083,11.954l.5,3.728.132,1.017a1.312,1.312,0,0,0,.07.349",
    transform: "translate(-24.398 -229.949)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_224",
    "data-name": "Line 224",
    y1: 21.064,
    x2: 8.375,
    transform: "translate(32.567 100.96)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M139.1,244.214c6.4-2.025,10.194,3.923,11.24,7.473a14.7,14.7,0,0,1-.8,10.684c-1.082,2.3-2.532,4.693-2.271,7.11a28.1,28.1,0,0,0,.808,3.043,3.627,3.627,0,0,1-.51,3.114c-1.3,1.584-3.726,1.009-5.471.308a3.276,3.276,0,0,1-1.987,3.058,9.086,9.086,0,0,1-3.744.692,49.781,49.781,0,0,1-13.229-1.747c-3.64-1.026-5.215-2.405-6.476-5.918-.508-1.431-.682-3.037-1.562-4.256-1.024-1.412-2.8-2.04-4.22-3.068s-2.513-2.958-1.555-4.588a13.337,13.337,0,0,1,1.453-1.642,1.862,1.862,0,0,0,.5-1.942c-.257-.482-.852-.655-1.326-.922-1.141-.64-9.205,4.18-9.592,2.926,0,0,10.369-11.788,19.359-15.478,2.889-1.193,8.99-3.682,12-3.971,4.13-.391,7.611,4.519,7.378,5.136",
    transform: "translate(-18.73 -239.067)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M139.572,247.192c4.125,2.231,5.637,8.935,3.235,12.961-2.662,4.472-6.1,9.822-8.8,12.672-5.422,5.738-10.922,3.168-10.922,3.168l-7.563,9.97-8.338-18.359,16.923-24.482,1.38-2.1Z",
    transform: "translate(-17.553 -238.73)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M121.029,272.884a20.618,20.618,0,0,1-7.245-8.361s-1,5.943,6.066,9.921Z",
    transform: "translate(-16.425 -234.684)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M124.288,263.792",
    transform: "translate(-14.609 -234.81)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M123.986,240.342a3.026,3.026,0,0,1,1.96.2,98.1,98.1,0,0,1,12.036,5.037l.424,1.872a8.29,8.29,0,0,1-8.851,2.578c-1.238-.416-2.678-1.107-3.738-.34s-.826,2.455-1.1,3.778a4.234,4.234,0,0,1-3.385,3.268c-.932.156-1.9-.013-2.823.185a4.215,4.215,0,0,0-2.789,2.326,7.223,7.223,0,0,0-.91,4.012,7.191,7.191,0,0,1-2.79-7.871,11.421,11.421,0,0,1,3.052-4.246,65.669,65.669,0,0,0,7.477-9.383A3.123,3.123,0,0,1,123.986,240.342Z",
    transform: "translate(-16.768 -238.861)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M133.9,244.771a16.258,16.258,0,0,0-.141,5.084,5.536,5.536,0,0,0,2.775,4.065c.056-.584.109-1.172.177-1.751a24.471,24.471,0,0,0,3.441,9.519c.472-3.279.941-6.64.225-9.878s-2.88-6.365-6.068-7.253",
    transform: "translate(-13.001 -238.122)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M119.722,244.82l.89,11.311c-1.523,0-3.365,2.217-3.522,3.729s.028,3.155-.794,4.437c-.893,1.4-2.7,1.894-3.943,3-1.762,1.558-2.192,4.09-2.854,6.347s-2.058,4.724-4.4,5.011c-2.634.324-4.744-2.456-4.962-5.1s.821-5.21,1.353-7.8.105-5.5-1.86-7.279A50.71,50.71,0,0,1,119.722,244.82Z",
    transform: "translate(-18.854 -238.077)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M127.728,277.775l-7.168,14.461s25.8-1.014,35.4-3.044c9.383-1.949,25.244-15.075,27.865-17.2l.008.011c1.551-1.116,3.827-5.671,5.655-9.032a2.054,2.054,0,0,0,2.3-.212l2.3-1.237-2.045-4.353c-2.158-2.806-9.545-.489-9.66.822a3.829,3.829,0,0,1-.625,1.653,2.568,2.568,0,0,0-.449,1.194c-.149,1.445-.7,4.536-2.493,6.079l-.009.009c-5.446,3.722-14.656,6.072-23.269,9.328C146.575,279.636,127.728,277.775,127.728,277.775Z",
    transform: "translate(-15.251 -236.179)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M31.55,244.7c.9.615,4.97,3.437,4.97,3.437l-.083.755s-2.546-.022-2.844.591a1.319,1.319,0,0,0,.006,1.551c.388.415,2.62,4.294,3.153,4.765a1.569,1.569,0,0,0,.9.28s4.367,1.859,5.4,2.26a6.1,6.1,0,0,0,2.518.179v-.026c2.254.505,27.654,6.246,32.781,7.659,5.377,1.473,29.922,8.224,34.387,6.886l2.457-5.969-4.246-7.992s-7.917.261-12.729-.859-23.243-4.3-23.243-4.3l-29.131-3-1.566-1.285a34.692,34.692,0,0,0-4.385-4.21c-.987-.713-8.448-2.664-8.918-2.531C30.528,243.02,30.634,244.087,31.55,244.7Z",
    transform: "translate(-30.718 -238.41)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M93.064,282.975a2.349,2.349,0,0,0,.138.622,9.858,9.858,0,0,0,.654,1.592,12.259,12.259,0,0,0,3.624,4.4,11.981,11.981,0,0,0,5.228,2.245,10.074,10.074,0,0,0,1.721.142,2.517,2.517,0,0,0,.635-.054c0-.062-.907-.016-2.309-.281a12.672,12.672,0,0,1-5.1-2.268,12.888,12.888,0,0,1-3.62-4.242C93.357,283.847,93.118,282.974,93.064,282.975Z",
    transform: "translate(-19.984 -231.508)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M123.375,283.194s-8.98-19.886-9.308-20.525a17.262,17.262,0,0,0-7.96-6.142c-6.054-2.265-14.6-2.507-14.6-2.507a17.7,17.7,0,0,1-10.784,14.2h0l13.7,3.807L89.245,281.9s-1.725,4.444-5.822,5.894c-7.752,2.745-20.322,6.706-20.784,8.233-.045.161,3.438-2.337,10.41,1.961,2.108,1.308,5.034,4.5,7.089,7.937,8.855,14.761,7.5,24.812,7.768,27.126,0,0,17.811-20.933,22.063-22.586s7.492-2.254,9.367-5.792,5.011-9.141,5.011-9.141l10.041-.154,5.16-17.27-10.942-1.532Z",
    transform: "translate(-25.223 -236.493)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M109.97,290.723a20.51,20.51,0,0,1-1.99,1.257,10.471,10.471,0,0,1-5.466,1.107,11.2,11.2,0,0,1-5.279-1.831,46.893,46.893,0,0,1-4.317-3.647",
    transform: "translate(-20.01 -230.71)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M120.255,287.175a6.239,6.239,0,0,0-3.24,1.2,6.33,6.33,0,0,0-2.341,2.546",
    transform: "translate(-16.264 -230.785)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M89.059,271.025a3.155,3.155,0,0,0,1.105-.681,6.836,6.836,0,0,0,1.877-2.5,7.073,7.073,0,0,0,.6-3.073,3.284,3.284,0,0,0-.256-1.293",
    transform: "translate(-20.674 -234.865)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M75.2,284.43c-.026.023.577.135,1.548.554a11.064,11.064,0,0,1,3.6,2.6,16.124,16.124,0,0,1,3.388,5.664,41.818,41.818,0,0,1,1.762,7.939,74.87,74.87,0,0,0,3.424,14.468c.636,1.806,1.207,3.227,1.628,4.2.2.492.376.866.505,1.13a2.074,2.074,0,0,0,.195.38",
    transform: "translate(-23.059 -231.257)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M84.486,281.068",
    transform: "translate(-21.461 -231.836)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M83.284,280.949a10.818,10.818,0,0,1,1.4.239,7.825,7.825,0,0,1,3.286,1.913,12.421,12.421,0,0,1,2.99,4.8,66.525,66.525,0,0,1,1.921,6.769,60.9,60.9,0,0,0,2.021,6.774,24.153,24.153,0,0,0,2.658,5.134,15.979,15.979,0,0,0,2.573,2.921,10.464,10.464,0,0,0,.831.659",
    transform: "translate(-21.668 -231.856)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M102.226,292.352a3.3,3.3,0,0,0,.028.484,3.817,3.817,0,0,0,.1.563,6.5,6.5,0,0,0,.186.728,9.815,9.815,0,0,0,.765,1.809,11.446,11.446,0,0,0,1.382,1.97,11.649,11.649,0,0,0,1.8,1.6,9.665,9.665,0,0,0,1.694.987,6.767,6.767,0,0,0,.7.278,3.521,3.521,0,0,0,.546.163,1.406,1.406,0,0,0,.475.084",
    transform: "translate(-18.407 -229.893)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M87.275,274.075a1.206,1.206,0,0,0,.007.3,5.116,5.116,0,0,0,.156.86,8.1,8.1,0,0,0,1.418,2.874,13.987,13.987,0,0,0,3.511,3.206c1.5,1.019,3.241,1.907,4.981,2.987a25.359,25.359,0,0,1,7.489,7.223c.6.879,1.53,2.629,2.016,3.574",
    transform: "translate(-20.982 -233.04)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M93.12,269.312a1.776,1.776,0,0,0,.21.318c.166.182.343.482.654.874a20.761,20.761,0,0,0,2.9,2.757c1.325,1.053,3,2.163,4.884,3.361a43.588,43.588,0,0,1,5.839,4.226,18.63,18.63,0,0,1,1.314,1.355c.21.23.416.456.6.7l.527.736a16.557,16.557,0,0,1,1.64,3.048c.863,2.047,1.464,3.973,2.145,5.522a14.823,14.823,0,0,0,2,3.465,6.018,6.018,0,0,0,.733.8,1.6,1.6,0,0,0,.282.259",
    transform: "translate(-19.975 -233.86)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M92.207,270.548a3.086,3.086,0,0,0,.7-.179,11.3,11.3,0,0,0,1.83-.785,12.417,12.417,0,0,0,4.753-4.451,12.224,12.224,0,0,0,1.738-6.265,11.169,11.169,0,0,0-.182-1.966,3.26,3.26,0,0,0-.181-.747",
    transform: "translate(-20.132 -236.125)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M127.79,282.52c-.072-.168.019-.5-.12-.615a3.252,3.252,0,0,0-1.254-.765,6.183,6.183,0,0,0-2.161-.321c-.8-.008-1.7.1-2.616.054a4.677,4.677,0,0,1-2.409-.757,8.119,8.119,0,0,1-1.574-1.4,10.793,10.793,0,0,0-1.307-1.521",
    transform: "translate(-15.976 -232.503)",
    fill: "#fff",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M122.219,273.428s-11.313-5.415-8.864-16.825",
    transform: "translate(-16.551 -236.048)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M70.75,273.975c-7.944,0-14.384,23.218-14.384,51.86s6.44,51.86,14.384,51.86",
    transform: "translate(-26.303 -233.057)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M315.176,127.7l-5.619-5.621a1.061,1.061,0,0,1,.75-1.811h5.619a1.062,1.062,0,0,1,1.062,1.061v5.621A1.062,1.062,0,0,1,315.176,127.7Z",
    transform: "translate(47.953 8.149)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M161.186,187.8a1.533,1.533,0,0,1,0,2.161,1.525,1.525,0,0,1-2.157,0l-2.248-2.248-2.248,2.248a1.528,1.528,0,0,1-2.161-2.161l2.248-2.248-2.248-2.248a1.527,1.527,0,0,1,2.161-2.157l2.248,2.248,2.248-2.248a1.527,1.527,0,0,1,2.157,0,1.525,1.525,0,0,1,0,2.157l-2.248,2.248Z",
    transform: "translate(20.868 18.554)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M268.443,112.447a9.206,9.206,0,0,1-.3,2.348H240a5.875,5.875,0,0,1,9.989-4.2,9.318,9.318,0,0,1,18.449,1.856Z",
    transform: "translate(36.032 5.199)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M154.535,135.412H97.708a8.744,8.744,0,0,1,8.744-8.744,8.657,8.657,0,0,1,6.072,2.462l.035.035A13.91,13.91,0,0,1,123.2,118.38c.363-.082.727-.141,1.09-.188a5.1,5.1,0,0,1,.61-.07,3.316,3.316,0,0,1,.481-.035c.223-.012.434-.023.656-.023h.164c.223,0,.434.012.656.023a3.315,3.315,0,0,1,.481.035,5.6,5.6,0,0,1,.621.07c.2.023.4.059.6.094.352.059.692.141,1.031.223a14.049,14.049,0,0,1,1.981.668,13.9,13.9,0,0,1,8.111,9.987l.035-.035a8.737,8.737,0,0,1,14.816,6.283Z",
    transform: "translate(11.533 7.77)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 4.593,
    cy: 4.593,
    r: 4.593,
    transform: "translate(190.922 348.183)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 3.392,
    cy: 3.392,
    r: 3.392,
    transform: "translate(374.255 119.19)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 8.239,
    cy: 8.239,
    r: 8.239,
    transform: "translate(394.42 100.092)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_225",
    "data-name": "Line 225",
    x2: 9.755,
    transform: "translate(245.635 150.471)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_226",
    "data-name": "Line 226",
    x2: 9.755,
    transform: "translate(428.563 72.935)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesImg3);
export default __webpack_public_path__ + "static/media/Services_img_3.8d034171b065ef35eb7f8adfa2236419.svg";
export { ForwardRef as ReactComponent };